

export const dashboardColumns = [

 
 
 {
    field: "division",
    headerName: "Division",
    pinned: "left",
    filter: true
},
  { field: "district", headerName: "District", filter: true,pinned: "left",filter: true},
  { field: "ulb_code", headerName: "ULB Code",  filter: true,pinned: "left" }, 
  { field: "ulb_name", headerName: "ULB Name", filter: true ,pinned: "left",filter: true},
  { field: "lulc",headerName: "LULC", filter: true,editable: params => params.data.ulb_code === params.context.editingRow
  },
  { field: "phase", headerName: "Phase", filter: true,editable: params => params.data.ulb_code === params.context.editingRow },
  { field: "clusterdata", headerName: "Cluster", filter: true ,editable: params => params.data.ulb_code === params.context.editingRow},
{
  field: "total_properties_mis",
  headerName: "Total Properties MIS",filter: true,
  editable: params => params.data.ulb_code === params.context.editingRow
},
{
  field: "no_of_enp_ids_available",
  headerName: "No. of ENP IDs Available",
  filter: true,editable: params => params.data.ulb_code === params.context.editingRow
},
{
  field: "electricity_ids",
  headerName: "Electricity IDs",
  filter: true,editable: params => params.data.ulb_code === params.context.editingRow 
},
{
  field: "water_connection_id",
  headerName: "Water Connection ID",
  filter: true,editable: params => params.data.ulb_code === params.context.editingRow
},
{
  field: "municipal_connections",
  headerName: "Municipal Connections",
  filter: true,editable: params => params.data.ulb_code === params.context.editingRow
},
{
  field: "mobile_no",
  headerName: "Mobile No.",
  filter: true,editable: params => params.data.ulb_code === params.context.editingRow
},



  {
    field: "gis_mphs_survey_status",
    headerName: "GIS MPHS Survey Status",
    filter: true,editable: params => params.data.ulb_code === params.context.editingRow
  },

  {
    field: "properties_registered_before_gis",
    headerName: "Properties Before GIS",
    filter: true,editable: params => params.data.ulb_code === params.context.editingRow
  },

  {
    field: "after_mphs_survey_properties",
    headerName: "Properties After MPHS",
    filter: true,editable: params => params.data.ulb_code === params.context.editingRow
  },

  {
    field: "demand_before_gis",
    headerName: "Demand Before GIS",
    filter: true,editable: params => params.data.ulb_code === params.context.editingRow
  },

  {
    field: "demand_after_gis",
    headerName: "Demand After GIS",
    filter: true,editable: params => params.data.ulb_code === params.context.editingRow
  },

  {
    field: "enp_2_0",
    headerName: "ENP 2.0",
    filter: true,editable: params => params.data.ulb_code === params.context.editingRow
  },

  {
    field: "new_property_identify_status",
    headerName: "New Property Status",
    filter: true,editable: params => params.data.ulb_code === params.context.editingRow
  },

  {
    field: "identified_property_count",
    headerName: "Identified Property Count",
    filter: true,editable: params => params.data.ulb_code === params.context.editingRow
  },

  { field: "sewer_network", filter: true,editable: params => params.data.ulb_code === params.context.editingRow },
  { field: "manhole", filter: true,editable: params => params.data.ulb_code === params.context.editingRow },
  { field: "ips", filter: true,editable: params => params.data.ulb_code === params.context.editingRow },
  { field: "mps", filter: true,editable: params => params.data.ulb_code === params.context.editingRow },
  { field: "stp", filter: true,editable: params => params.data.ulb_code === params.context.editingRow },
  { field: "distribution_network", filter: true,editable: params => params.data.ulb_code === params.context.editingRow },
  { field: "intakewell", filter: true,editable: params => params.data.ulb_code === params.context.editingRow },
  { field: "junction", filter: true,editable: params => params.data.ulb_code === params.context.editingRow },
  { field: "cwpm", filter: true,editable: params => params.data.ulb_code === params.context.editingRow },
  { field: "rwpm", filter: true,editable: params => params.data.ulb_code === params.context.editingRow },
  { field: "wtp", filter: true,editable: params => params.data.ulb_code === params.context.editingRow },
  { field: "oht", filter: true,editable: params => params.data.ulb_code === params.context.editingRow },
  { field: "sampada", filter: true,editable: params => params.data.ulb_code === params.context.editingRow },
  { field: "masterplan", filter: true,editable: params => params.data.ulb_code === params.context.editingRow },

  {
    field: "garud_gis_upload",
    headerName: "Garud GIS Upload",
    filter: true,editable: params => params.data.ulb_code === params.context.editingRow
  },

  {
    field: "garud_mis_upload",
    headerName: "Garud MIS Upload",
    filter: true,editable: params => params.data.ulb_code === params.context.editingRow
  },

  {
    field: "municipal_boundary",
    headerName: "Municipal Boundary",
    filter: true,editable: params => params.data.ulb_code === params.context.editingRow
  },

  {
    field: "municipal_ward",
    headerName: "Municipal Ward",
    filter: true,editable: params => params.data.ulb_code === params.context.editingRow
  },

  { field: "properties", filter: true ,editable: params => params.data.ulb_code === params.context.editingRow},

  {
    field: "building_footprint",
    headerName: "Building Footprint",
    filter: true ,editable: params => params.data.ulb_code === params.context.editingRow
  },

  {
    field: "plot_building_structure",
    headerName: "Plot Building Structure",
    filter: true ,editable: params => params.data.ulb_code === params.context.editingRow
  },

  {
    field: "builtup_area",
    headerName: "Builtup Area",
    filter: true
  },

  {
    field: "slum_area",
    headerName: "Slum Area",
    filter: true ,editable: params => params.data.ulb_code === params.context.editingRow
  },

  {
    field: "agriculture_area",
    headerName: "Agriculture Area",
    filter: true ,editable: params => params.data.ulb_code === params.context.editingRow
  },

  {
    field: "vacant_land",
    headerName: "Vacant Land",
    filter: true ,editable: params => params.data.ulb_code === params.context.editingRow
  },

  {
    field: "waste_land",
    headerName: "Waste Land",
    filter: true ,editable: params => params.data.ulb_code === params.context.editingRow
  },

  {
    field: "forest",
    headerName: "Forest",
    filter: true ,editable: params => params.data.ulb_code === params.context.editingRow
  },

  {
    field: "open_land",
    headerName: "Open Land",
    filter: true   ,editable: params => params.data.ulb_code === params.context.editingRow
  },

  {
    field: "road",
    headerName: "Road",
    filter: true ,editable: params => params.data.ulb_code === params.context.editingRow
  },

  {
    field: "railway",
    headerName: "Railway",
    filter: true ,editable: params => params.data.ulb_code === params.context.editingRow
  },

  {
    field: "railway_station",
    headerName: "Railway Station",
    filter: true ,editable: params => params.data.ulb_code === params.context.editingRow
  },

  {
    field: "airport",
    headerName: "Airport",
    filter: true ,editable: params => params.data.ulb_code === params.context.editingRow
  },

  {
    field: "busstand",
    headerName: "Bus Stand",
    filter: true ,editable: params => params.data.ulb_code === params.context.editingRow
  },

  {
    field: "river",
    headerName: "River",
    filter: true ,editable: params => params.data.ulb_code === params.context.editingRow
  },

  {
    field: "drainage_nala",
    headerName: "Drainage Nala",
    filter: true ,editable: params => params.data.ulb_code === params.context.editingRow
  },

  {
    field: "canals",
    headerName: "Canals",
    filter: true ,editable: params => params.data.ulb_code === params.context.editingRow
  },

  {
    field: "lake_pond",
    headerName: "Lake Pond",
    filter: true ,editable: params => params.data.ulb_code === params.context.editingRow
  },

  {
    field: "colony_name",
    headerName: "Colony Name",
    filter: true ,editable: params => params.data.ulb_code === params.context.editingRow
  },

  {
    field: "important_landmarks",
    headerName: "Important Landmarks",
    filter: true ,editable: params => params.data.ulb_code === params.context.editingRow
  },

  {
    field: "remark",
    headerName: "Remark",
    filter: true ,editable: params => params.data.ulb_code === params.context.editingRow
  }
];